import React from 'react';
import { DisplayPosition } from '@/common/manager/position//display-position';
import { dataOriginRequest, dataOriginStatic } from '@/common/util/const';
import { calculateTextExprValue, isArrayNotEmpty } from '@/common/util/util';
import { transRequestConfigToRemote } from '@/common/util/request';
function renderEnumOne(enumMap, value) {
    if (value !== undefined) {
        const label = enumMap[value];
        if (label !== undefined) {
            return label;
        }
    }
    else {
        return '';
    }
    return value;
}
export const config = {
    componentName: 'enumeration',
    position: DisplayPosition.tableCell,
    beforeHandler: (props, config) => {
        const { _context } = config || {};
        const { format, options, componentName } = props || {};
        if (format === 'enumeration') {
            const { enumDataOrigin, enumRequestConfig, enumDataSource } = options || {};
            if (enumDataOrigin === dataOriginRequest && enumRequestConfig) {
                props.options = {
                    mode: componentName,
                    requestConfig: transRequestConfigToRemote({
                        requestConfig: enumRequestConfig,
                        state: _context?.state,
                        needFormatResult: true,
                    }),
                };
            }
            else if (enumDataOrigin === dataOriginStatic) {
                const realDataSource = calculateTextExprValue(enumDataSource, {
                    state: _context?.state,
                    recordDataSource: _context?.state,
                });
                if (isArrayNotEmpty(realDataSource)) {
                    props.options = {
                        mode: componentName,
                        dataSource: realDataSource,
                    };
                }
            }
        }
    },
    component: (props) => {
        let result;
        const { value, enumMap = {} } = props;
        if (Array.isArray(value)) {
            result = value
                .map((item) => renderEnumOne(enumMap, item))
                .filter((item) => item !== undefined && item !== '')
                .join(', ');
        }
        else {
            result = renderEnumOne(enumMap, value);
        }
        return <div style={{ display: 'flex', flexWrap: 'noWrap' }}>{result}</div>;
    },
};
